import qs from 'qs';

export const getQueryParams = (): { [key: string]: unknown } => {
  const { href, pathname } = new URL(document.URL);
  const rawParams = href.substring(href.indexOf(pathname) + pathname.length);
  return qs.parse(rawParams.replace('?', ''), { decoder: (str) => str });
};
